import { computed, Injectable } from '@angular/core';
import { map, take } from 'rxjs/operators';

import { MarketplaceStoreSelector } from '@app/common/selectors/marketplace.selector';
import { PluginTypes } from '@config/values/plugin-types.values';

@Injectable({ providedIn: 'root' })
export class MarketplaceStoreRefiner {
  selectIsComoPluginEnabled = this._selector.selectMarketplacePlugins$.pipe(
    take(1),
    map(plugins => plugins?.find(plugin => plugin.type === PluginTypes.Como)),
    map(plugin => plugin?.plugin_enabled),
  );

  selectIsZeroSixPluginEnabled = this._selector.selectMarketplacePlugins$.pipe(
    take(1),
    map(plugins => plugins?.find(plugin => plugin.type === PluginTypes.Zerosix)),
    map(plugin => plugin?.plugin_enabled),
  );

  selectIsPongoPluginEnabled = this._selector.selectMarketplacePlugins$.pipe(
    take(1),
    map(plugins => plugins?.find(plugin => plugin.type === PluginTypes.Pongo)),
    map(plugin => plugin?.plugin_enabled),
  );

  selectIsPongoPluginEnabledSignal = computed(
    () =>
      this._selector.selectMarketplacePlugins()?.find(plugin => plugin.type === PluginTypes.Pongo)
        ?.plugin_enabled ?? false,
  );

  constructor(private _selector: MarketplaceStoreSelector) {}
}
